import React from 'react';
import { CommunicationAcceptance } from '../../logic/components';

const CommunicationAcceptanceRoute = () => {
  return (
    <div className="container">
      <div id="container1">
        <CommunicationAcceptance />
      </div>
    </div>
  );
};

export default React.memo(CommunicationAcceptanceRoute);
